import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d1c0fdce"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "mb-2"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "时段"), /*#__PURE__*/_createElementVNode("th", null, "电费/度元")], -1);
});
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "4"
  }, "暂无数据", -1);
});
var _hoisted_5 = [_hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("table", _hoisted_1, [_hoisted_2, _ctx.list.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.list, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.time_range), 1), _createElementVNode("td", null, _toDisplayString(item.electric_price), 1)]);
  }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_3, _hoisted_5))]);
}